import styled from 'styled-components';
import is from 'styled-is';

var taggedTemplateLiteral = function taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var _templateObject = taggedTemplateLiteral(['\n    display: inline-flex;\n  '], ['\n    display: inline-flex;\n  ']);

var _templateObject2 = taggedTemplateLiteral(['\n    flex-direction: row; /* default */\n  '], ['\n    flex-direction: row; /* default */\n  ']);

var _templateObject3 = taggedTemplateLiteral(['\n    flex-direction: row-reverse;\n  '], ['\n    flex-direction: row-reverse;\n  ']);

var _templateObject4 = taggedTemplateLiteral(['\n    flex-direction: column;\n  '], ['\n    flex-direction: column;\n  ']);

var _templateObject5 = taggedTemplateLiteral(['\n    flex-direction: column-reverse;\n  '], ['\n    flex-direction: column-reverse;\n  ']);

var _templateObject6 = taggedTemplateLiteral(['\n    flex-wrap: nowrap; /* default */\n  '], ['\n    flex-wrap: nowrap; /* default */\n  ']);

var _templateObject7 = taggedTemplateLiteral(['\n    flex-wrap: wrap;\n  '], ['\n    flex-wrap: wrap;\n  ']);

var _templateObject8 = taggedTemplateLiteral(['\n    flex-wrap: wrap-reverse;\n  '], ['\n    flex-wrap: wrap-reverse;\n  ']);

var _templateObject9 = taggedTemplateLiteral(['\n    justify-content: flex-start; /* default */\n  '], ['\n    justify-content: flex-start; /* default */\n  ']);

var _templateObject10 = taggedTemplateLiteral(['\n    justify-content: flex-end;\n  '], ['\n    justify-content: flex-end;\n  ']);

var _templateObject11 = taggedTemplateLiteral(['\n    justify-content: center;\n  '], ['\n    justify-content: center;\n  ']);

var _templateObject12 = taggedTemplateLiteral(['\n    justify-content: space-between;\n  '], ['\n    justify-content: space-between;\n  ']);

var _templateObject13 = taggedTemplateLiteral(['\n    justify-content: space-around;\n  '], ['\n    justify-content: space-around;\n  ']);

var _templateObject14 = taggedTemplateLiteral(['\n    align-content: flex-start;\n  '], ['\n    align-content: flex-start;\n  ']);

var _templateObject15 = taggedTemplateLiteral(['\n    align-content: flex-end;\n  '], ['\n    align-content: flex-end;\n  ']);

var _templateObject16 = taggedTemplateLiteral(['\n    align-content: center;\n  '], ['\n    align-content: center;\n  ']);

var _templateObject17 = taggedTemplateLiteral(['\n    align-content: space-between;\n  '], ['\n    align-content: space-between;\n  ']);

var _templateObject18 = taggedTemplateLiteral(['\n    align-content: space-around;\n  '], ['\n    align-content: space-around;\n  ']);

var _templateObject19 = taggedTemplateLiteral(['\n    align-content: stretch; /* default */\n  '], ['\n    align-content: stretch; /* default */\n  ']);

var _templateObject20 = taggedTemplateLiteral(['\n    align-items: flex-start;\n  '], ['\n    align-items: flex-start;\n  ']);

var _templateObject21 = taggedTemplateLiteral(['\n    align-items: flex-end;\n  '], ['\n    align-items: flex-end;\n  ']);

var _templateObject22 = taggedTemplateLiteral(['\n    align-items: center;\n  '], ['\n    align-items: center;\n  ']);

var _templateObject23 = taggedTemplateLiteral(['\n    align-items: baseline;\n  '], ['\n    align-items: baseline;\n  ']);

var _templateObject24 = taggedTemplateLiteral(['\n    align-items: stretch;\n  '], ['\n    align-items: stretch;\n  ']);

var _templateObject25 = taggedTemplateLiteral(['\n    width: 100%;\n    height: 100%;\n    flex-basis: 100%;\n  '], ['\n    width: 100%;\n    height: 100%;\n    flex-basis: 100%;\n  ']);

var _templateObject26 = taggedTemplateLiteral(['\n    align-items: center;\n    justify-content: center;\n  '], ['\n    align-items: center;\n    justify-content: center;\n  ']);

var flex = styled.div.withConfig({
  displayName: 'flex',
  componentId: 'x9ump0-0'
})(['display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-content:stretch;', ';', ';', ';', ';', ';', ';', ';', ';', ';', ';', ';', ';', ';', ';', ';', ';', ';', ';', ';', ';', ';', ';', ';', ';', ';', ';'], is('inline')(_templateObject), is('row')(_templateObject2), is('rowReverse')(_templateObject3), is('column')(_templateObject4), is('columnReverse')(_templateObject5), is('nowrap')(_templateObject6), is('wrap')(_templateObject7), is('wrapReverse')(_templateObject8), is('justifyStart')(_templateObject9), is('justifyEnd')(_templateObject10), is('justifyCenter')(_templateObject11), is('justifyBetween')(_templateObject12), is('justifyAround')(_templateObject13), is('contentStart')(_templateObject14), is('contentEnd')(_templateObject15), is('contentCenter')(_templateObject16), is('contentSpaceBetween')(_templateObject17), is('contentSpaceAround')(_templateObject18), is('contentStretch')(_templateObject19), is('alignStart')(_templateObject20), is('alignEnd')(_templateObject21), is('alignCenter')(_templateObject22), is('alignBaseline')(_templateObject23), is('alignStretch')(_templateObject24), is('full')(_templateObject25), is('center')(_templateObject26));

var _templateObject$1 = taggedTemplateLiteral(['\n    display: inline-block;\n  '], ['\n    display: inline-block;\n  ']);

var _templateObject2$1 = taggedTemplateLiteral(['\n    display: inline-flex;\n  '], ['\n    display: inline-flex;\n  ']);

var _templateObject3$1 = taggedTemplateLiteral(['\n    display: flex;\n  '], ['\n    display: flex;\n  ']);

var _templateObject4$1 = taggedTemplateLiteral(['\n    order: ', ';\n  '], ['\n    order: ', ';\n  ']);

var _templateObject5$1 = taggedTemplateLiteral(['\n    flex-basis: ', ';\n  '], ['\n    flex-basis: ', ';\n  ']);

var _templateObject6$1 = taggedTemplateLiteral(['\n    flex-grow: ', ';\n  '], ['\n    flex-grow: ', ';\n  ']);

var _templateObject7$1 = taggedTemplateLiteral(['\n    flex-shrink: ', ';\n  '], ['\n    flex-shrink: ', ';\n  ']);

var _templateObject8$1 = taggedTemplateLiteral(['\n    flex-shrink: 0;\n  '], ['\n    flex-shrink: 0;\n  ']);

var item = styled.div.withConfig({
  displayName: 'item',
  componentId: 'pyuzpd-0'
})(['order:0;flex-basis:auto;flex-grow:0;flex-shrink:1;display:block;', ';', ';', ';', ';', ';', ';', ';', ';'], is('inlineBlock')(_templateObject$1), is('inlineFlex')(_templateObject2$1), is('flex')(_templateObject3$1), is('order')(_templateObject4$1, function (props) {
  return props.order;
}), is('basis')(_templateObject5$1, function (props) {
  return props.basis;
}), is('grow')(_templateObject6$1, function (props) {
  return props.grow;
}), is('shrink')(_templateObject7$1, function (props) {
  return props.shrink;
}), is('noShrink')(_templateObject8$1));
export default flex;
export { item as FlexItem };